/* eslint-disable import/prefer-default-export */
import _ from "underscore";
import { allQuotesDouble, allQuotesDoubleTemporary, allQuotesSingle } from "lib/helpers/mediaHelpers.js";

export const combineDataExlorerFilters = ({ filterTypeIds, entityFilters, filterMaps }) => {
	let filtersList = [...entityFilters];
	_.each(filterTypeIds, (filterId) => {
		filtersList = [...filtersList, ...filterMaps[filterId].values()];
	});

	return filtersList;
};

export const getAllFilterIds = ({ filterTypeIds, entityFilters, filterMaps }) => {
	const allFilters = combineDataExlorerFilters({ filterTypeIds, entityFilters, filterMaps });
	return _.pluck(allFilters, "id");
};

export const formatEntityType = (code) => {
	let string = "";
	switch (code) {
		case "DATE":
			string = "Dates";
			break;
		case "GPE":
			string = "Location";
			break;
		case "LAW":
			string = "Legal";
			break;
		case "ORG":
			string = "Organizations";
			break;
		case "PRODUCT":
			string = "Product";
			break;
		case "LOC":
			string = "Location";
			break;
		case "MONEY":
			string = "Currency";
			break;
		case "PERSON":
			string = "People";
			break;
		// case "TIME":
		// 	string = "Time";
		// 	break;
		default:
			string = code;
	}
	return string;
};

// return { lat: Number, lng: Number } or false, if gpsString is malformed;
// gpsString: "11.1234, 12.1234"
export const formatLatLong = ({ gpsString }) => {
	let latLong = false;

	if (gpsString) {
		const gps = gpsString.split(", ");

		if (gps && gps.length === 2) {
			latLong = {
				lat: Number(gps[0]),
				lng: Number(gps[1]),
			};
		}
	}

	return latLong;
};

export const haveFiltersChanged = ({ filtersList, queryId, savedSearches }) => {
	const activeSearch =
		queryId &&
		_.find(savedSearches, (search) => {
			return search.id === queryId;
		});

	if (!activeSearch) {
		return false;
	} else {
		// hydrate saved filters & convert into a flat array
		const savedFilterObj = activeSearch.filterStr ? JSON.parse(allQuotesDoubleTemporary(activeSearch.filterStr)) : {};
		const entityFilters = savedFilterObj.entityFilters || [];
		const filters = savedFilterObj.filters || [];
		const savedFilters = [...entityFilters, ...filters];

		// convert filter sets into easily comparable data structures
		const savedFilterIds = _.pluck(savedFilters, "id");
		const currentFilterIds = _.pluck(filtersList, "id");
		const filtersAreDifferent = !_.isEqual(savedFilterIds, currentFilterIds);

		return filtersAreDifferent;
	}
};

export const isSearchSaved = ({ queryId, queryString, entityFilters, filterMaps, filterTypeIds, savedSearches }) => {
	const activeSearch =
		queryId &&
		_.find(savedSearches, (search) => {
			return search.id === queryId;
		});

	if (!activeSearch) {
		return false;
	} else {
		const queryIsDifferent = allQuotesDouble(activeSearch.query) !== allQuotesDouble(queryString);
		if (queryIsDifferent) {
			return false;
		} else {
			const filtersList = combineDataExlorerFilters({ filterTypeIds, entityFilters, filterMaps });
			const filtersAlsoTheSame = !haveFiltersChanged({ filtersList, queryId, savedSearches });

			return filtersAlsoTheSame;
		}
	}
};

export const stringifyDataExplorerSearchFilters = ({ entityFilters, filters }) => {
	const string = allQuotesSingle(JSON.stringify({ entityFilters, filters }));
	return string;
};

// Returns a number.
// Expects either 123456, "Y123456", or "123456"
// 		- "$123456" will fail
export const yuanStringToNumber = (mayBeString) => {
	const stringHasY = _.isString(mayBeString) && mayBeString.slice(0, 1).toLowerCase() === "y";
	const number = _.isNumber(mayBeString) ? mayBeString : stringHasY ? Number(mayBeString.slice(1)) : Number(mayBeString);
	return number;
};
